interface LegendItem {
  label: string
  color: string
}

interface ChartLegendProps {
  items: LegendItem[]
  direction?: 'horizontal' | 'vertical'
  className?: string
}

export function ChartLegend({ items, direction = 'horizontal', className = '' }: ChartLegendProps) {
  return (
    <div
      className={`flex gap-4 text-xs font-[var(--font-family-body)] text-[var(--muted-foreground)] ${
        direction === 'vertical' ? 'flex-col gap-2' : 'flex-row flex-wrap justify-center'
      } ${className}`}
    >
      {items.map((item) => (
        <div key={item.label} className="flex items-center gap-1.5">
          <span
            className="inline-block h-2.5 w-2.5 shrink-0 rounded-full"
            style={{ backgroundColor: item.color }}
          />
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  )
}
